export const GAME_SET_SETTINGS = "game/setSettings";
export const GAME_INIT_SETTINGS = "game/initializeSettings";
